import React, { useEffect, useState } from "react";
import "./LoadingScreen.css";
import { Helmet } from "react-helmet-async";
import Intro from "../Introduction/Intro";

const LoadingScreen = () => {
  const [isLoadingComplete, setIsLoadingComplete] = useState(false);

  useEffect(() => {
    const hideBox = () => {
      const box = document.getElementsByClassName("box")[0];
      if (box) {
        box.style.display = "none";
        const text = document.getElementsByClassName("text")[0];
        if (text) {
          text.style.display = "flex";
          text.style.flexWrap = "wrap";
        }
      }
    };

    const adjustTextPosition = () => {
      const text = document.getElementsByClassName("text")[0];
      if (text) text.classList.add("pos");
    };

    const animateLetters = () => {
      const letters = document.getElementsByClassName("hide");
      let counter = 0;

      const showNextLetter = () => {
        if (letters && counter < letters.length) {
          letters[counter].classList.add("show" + counter);
          counter++;
          setTimeout(showNextLetter, 600);
        }
      };

      showNextLetter();

      setTimeout(() => {
        setIsLoadingComplete(true);
      }, 3500);
    };

    const boxTimer = setTimeout(hideBox, 820);
    const textTimer = setTimeout(adjustTextPosition, 1500);
    const letterTimer = setTimeout(animateLetters, 1000);

    return () => {
      clearTimeout(boxTimer);
      clearTimeout(textTimer);
      clearTimeout(letterTimer);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Welcome to VALSCO - Empowering Solutions</title>
        <meta
          name="description"
          content="Welcome to Valsco! We provide innovative software products and services to businesses and individuals, tailored to meet their unique needs. Explore our solutions today."
        />
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-EEZ3YQYH7K"
        ></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-EEZ3YQYH7K');
          `}
        </script>
      </Helmet>

      <div>
        {!isLoadingComplete ? (
          <div className="plan">
            <div className="box">
              <video src="tv.mp3" />
            </div>
            <div className="text">
              <span className="center sp">V</span>
              <span className="hide sp">A</span>
              <span className="hide sp">L</span>
              <span className="hide sp">S</span>
              <span className="hide sp">C</span>
              <span className="hide sp">O</span>
            </div>
          </div>
        ) : (
          <Intro className={isLoadingComplete ? "show" : "hide"} />
        )}
      </div>
    </>
  );
};

export default LoadingScreen;
